import React from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { DesignSystemProvider } from '@/design-system'
import { AxiosProvider } from '@/context/Axios'
import { SubscriptionProvider } from '@/context/SubscriptionContext'
import { useAuth, NotificationSocketBridge } from '@/hooks/common'
import '@/design-system/css/variables.css'

/** Auth + Axios + design system for /albums/* */
export function AlbumDesignRoot() {
  const { user } = useAuth()
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!user?.userID) navigate('/login')
  }, [user?.userID, navigate])

  if (!user?.userID) return null

  return (
    <AxiosProvider>
      <DesignSystemProvider>
        {/* Sibling to (not nested inside) the identically-named provider
            `pages/Layout.tsx` mounts for the legacy `/workspace`, `/topic`,
            etc. tree — that tree and this one never share a common
            ancestor below the router root, so every `useFeatureGate()`
            caller under here (AlbumLibraryScreen, GalleryWizardScreen,
            AlbumShellLayout, Studio3DScreen, ...) was silently hitting
            SubscriptionContext's no-op default (`showUpgrade: () =>
            undefined`) — clicking a gated action did nothing, with no
            error, instead of opening UpgradeModal. */}
        <SubscriptionProvider>
          {/* Notification socket lives here (not in a per-page screen) so it
              connects once and survives navigation across /albums, /galleries,
              /settings, /notification, etc. — the whole always-mounted shell
              for the real album product. */}
          <NotificationSocketBridge />
          <Outlet />
        </SubscriptionProvider>
      </DesignSystemProvider>
    </AxiosProvider>
  )
}
